import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListWithUs from "@/pages/ListWithUs";
import VacationHomes from "@/pages/VacationHomes";
import DominicanRepublic from "@/pages/DominicanRepublic";
import About from "@/pages/About";
import News from "@/pages/News";
import ArticlePage from "@/pages/ArticlePage";
import ListingDetail from "@/pages/ListingDetail";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const lenisStore = { current: null };

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisStore.current) {
      lenisStore.current.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisStore.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <main id="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/list-with-us" element={<ListWithUs />} />
            <Route path="/vacation-homes" element={<VacationHomes />} />
            <Route path="/dominican-republic" element={<DominicanRepublic />} />
            <Route path="/about" element={<About />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<ArticlePage />} />
            <Route path="/listing/:listingId" element={<ListingDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <div className="h-14 bg-obsidian md:hidden" aria-hidden="true" />
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0, fontFamily: '"Plus Jakarta Sans", sans-serif' } }} />
    </div>
  );
}

export default App;
